import { trackClientEvent } from '../../../../../trackClientEvent';
export const eventKey = 'core_collections-collections_page_sticky_cart-view';
/**
 * see Sticky Cart in the Collections page
 */
export function trackCoreCollectionsCollectionsPageStickyCartView() {
    return trackClientEvent({
        eventKey,
        realTimeTracking: false,
    });
}
